// extracted by mini-css-extract-plugin
export default {"image":"AboutSection_image__YEKc6","contentDiv":"AboutSection_contentDiv__ORl0q","btnClass":"AboutSection_btnClass__90HMp"};